var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, TemplateRef } from "@angular/core";
import { BsModalService } from "ngx-bootstrap";
import * as moment from "moment";
import { CandidatesService, TalentPoolListEntity, } from "../../services";
import { CandidateModel, UserJobsEntityModel, } from "app/interfaces";
import { environment } from "environments/environment";
import { ToasterService } from "angular2-toaster";
var TalentPoolExportBtnComponent = /** @class */ (function () {
    function TalentPoolExportBtnComponent(modalService, candidatesService, ts) {
        this.modalService = modalService;
        this.candidatesService = candidatesService;
        this.ts = ts;
        this.separator = ";";
        this.exporting = false;
        this.fileName = "";
        this.disabled = false;
        this.external = false;
        this.status = {
            student: "In progress",
            graduated: "Finished",
        };
    }
    TalentPoolExportBtnComponent.prototype.ngOnInit = function () {
        // console.log(this.candidates);
    };
    Object.defineProperty(TalentPoolExportBtnComponent.prototype, "isFilterFull", {
        get: function () {
            var variable = JSON.parse(JSON.stringify(this.filters));
            if (typeof variable !== 'object' || variable === null || Array.isArray(variable)) {
                return false;
            }
            if (Object.keys(variable).length === 0) {
                return false;
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    TalentPoolExportBtnComponent.prototype.convertCandidatesToCsv = function (candidates) {
        var _this = this;
        // console.log('candidates', candidates);
        // console.log('type', this.type);
        // console.log('referenceId', this.referenceId);
        var csv = "Candidate" +
            this.separator +
            "Birthdate" +
            this.separator +
            "Age" +
            this.separator +
            "City" +
            this.separator +
            "University" +
            this.separator +
            "Faculty" +
            this.separator +
            "Course" +
            this.separator +
            "Status" +
            this.separator +
            "Started at" +
            this.separator +
            "Finished at" +
            this.separator +
            "Expected finished at" +
            this.separator +
            "Qualification" +
            this.separator +
            "Vote" +
            this.separator +
            "Average" +
            this.separator +
            "Email" +
            this.separator +
            "Phone" +
            this.separator +
            "Address" +
            this.separator +
            "PDF Link" +
            this.separator +
            "Job Offer Id" +
            this.separator +
            "Job Offer Position" +
            this.separator +
            "Application Date" +
            this.separator +
            "Score" +
            this.separator +
            "Comment" +
            this.separator +
            "Process Status" +
            this.separator +
            "Tags";
        csv += "\n";
        this.fileName = "candidates";
        candidates.forEach(function (candidate) {
            candidate.User.UserJobs.forEach(function (job) {
                csv += candidate.User.name + " " + candidate.User.surname;
                csv += _this.separator;
                csv += candidate.User.birthdate
                    ? moment(candidate.User.birthdate).format("DD/MM/YYYY")
                    : "";
                csv += _this.separator;
                csv += candidate.User.birthdate
                    ? moment().diff(candidate.User.birthdate, "years")
                    : "";
                csv += _this.separator;
                var edu = candidate.User.AcademicQualifications.filter(function (aq) { return aq.is_current; })[0] || null;
                csv += edu && edu.City ? edu.City.name : "";
                csv += _this.separator;
                csv += edu && edu.university_name ? edu.university_name : "";
                csv += _this.separator;
                csv +=
                    edu && edu.StudyTag.MacroStudyTag
                        ? edu.StudyTag.MacroStudyTag.name_en.replace(/[^a-zA-Z0-9]/g, " ")
                        : "";
                csv += _this.separator;
                csv +=
                    edu && edu.course_name
                        ? edu.course_name.replace(/[^a-zA-Z0-9]/g, " ")
                        : "";
                csv += _this.separator;
                csv += edu && edu.status ? edu.status : "";
                csv += _this.separator;
                csv +=
                    edu && edu.started_at
                        ? moment(edu.started_at).format("DD/MM/YYYY")
                        : "";
                csv += _this.separator;
                csv +=
                    edu && edu.finished_at
                        ? moment(edu.finished_at).format("DD/MM/YYYY")
                        : "";
                csv += _this.separator;
                csv +=
                    edu && edu.expected_finished_at
                        ? moment(edu.expected_finished_at).format("DD/MM/YYYY")
                        : "";
                csv += _this.separator;
                csv +=
                    edu && edu.qualification_name
                        ? edu.qualification_name.replace(/[^a-zA-Z0-9]/g, " ")
                        : "";
                csv += _this.separator;
                csv += edu && edu.vote ? edu.vote : "";
                csv += _this.separator;
                csv += edu && edu.avg ? edu.avg : "";
                csv += _this.separator;
                csv += candidate.User.contact_email || "";
                csv += _this.separator;
                csv += candidate.User.contact_phone || "";
                csv += _this.separator;
                csv += candidate.User.geolocation
                    ? candidate.User.geolocation.formattedName.replace(/[^a-zA-Z0-9]/g, " ")
                    : "";
                csv += _this.separator;
                csv += environment.baseUrl + "/pdf-download/" + candidate.User.id + "/" + candidate.User.name + "-" + candidate.User.surname;
                csv += _this.separator;
                // job data
                csv += job.JobOffer.id;
                csv += _this.separator;
                csv += job.JobOffer.position.replace(/[^a-zA-Z0-9]/g, " ");
                csv += _this.separator;
                csv += job.applied_at;
                csv += _this.separator;
                csv += Math.round(job.user_score) * 100 + "%";
                csv += _this.separator;
                csv += job.comment
                    ? job.comment.replace(/[^a-zA-Z0-9]/g, " ")
                    : " ";
                csv += _this.separator;
                csv += job.process_status ? job.process_status : " ";
                csv += _this.separator;
                csv += job.Tags
                    ? job.Tags.map(function (a) { return a.name; })
                        .toString()
                        .replace(/[^a-zA-Z0-9]/g, " ")
                        .trim()
                    : "";
                csv += "\n";
            });
        });
        return csv;
    };
    TalentPoolExportBtnComponent.prototype.formatApplicationsToCSV = function (applications) {
        var _this = this;
        var headers = [
            /* 'Application ID',
            'User ID', */
            'Name',
            'Surname',
            'Email',
            'Phone',
            'Institute',
            'Study Tag',
            /* 'Study Level', */
            'Job Offer ID',
            'Position',
            'Applied At',
            'Tags'
            /* 'User Score',
            'Process Status',
            'Viewed',
            'CV Title',
            'CV Pages' */
        ];
        var rows = [];
        applications.forEach(function (app) {
            var user = app.User;
            var education = user.Education;
            var institute = education.Institute;
            var studyTag = education.StudyTag;
            var cv = app.Curriculum;
            var others = app.other_applications;
            others.forEach(function (otherApp, index) {
                var isFirst = index === 0;
                rows.push([
                    /*  isFirst ? app.id : '',
                     isFirst ? user.id : '', */
                    isFirst ? user.name : '',
                    isFirst ? user.surname : '',
                    isFirst ? user.contact_email : '',
                    isFirst ? user.phone : '',
                    isFirst ? institute.name : '',
                    isFirst ? studyTag.name_en : '',
                    /* isFirst ? education.study_tags_level : '', */
                    otherApp.jobOfferId || '',
                    otherApp.position || '',
                    otherApp.appliedAt || '',
                    otherApp.tags.join(', ')
                    /*  isFirst ? app.user_score : '',
                     isFirst ? app.process_status : '',
                     isFirst ? app.viewed : '',
                     isFirst ? cv.title : '',
                     isFirst ? cv.pages : '' */
                ]);
            });
        });
        var csvContent = [
            headers.join(this.separator)
        ].concat(rows.map(function (row) {
            return row.map(function (value) {
                return typeof value === 'string' && value.includes(',') ? "\"" + value + "\"" : value;
            }).join(_this.separator);
        })).join('\n');
        return csvContent;
    };
    TalentPoolExportBtnComponent.prototype.printCSV = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, csv;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.exporting = true;
                        return [4 /*yield*/, this.getCandidates()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TalentPoolExportBtnComponent.prototype.getCandidates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var page, limit, output, sanitizedFilters, blob, a, objectUrl;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        page = 0;
                        this.exporting = true;
                        this.disabled = true;
                        limit = 50;
                        output = [];
                        sanitizedFilters = JSON.parse(JSON.stringify(this.filters));
                        if (sanitizedFilters["job_offers_id"]) {
                            sanitizedFilters["job_offers_id"] =
                                sanitizedFilters["job_offers_id"].value;
                        }
                        if (sanitizedFilters["languages_id"]) {
                            sanitizedFilters["languages_id"] = Number(sanitizedFilters["languages_id"].value);
                        }
                        if (sanitizedFilters["language_level"]) {
                            sanitizedFilters["language_level"] = Number(sanitizedFilters["language_level"].value);
                        }
                        if (sanitizedFilters["cities_ids"] && sanitizedFilters["cities_ids"][0]) {
                            sanitizedFilters["cities_ids"][0] = sanitizedFilters["cities_ids"][0].id;
                        }
                        if (sanitizedFilters["institutes_ids"] &&
                            sanitizedFilters["institutes_ids"][0]) {
                            sanitizedFilters["institutes_ids"][0] =
                                sanitizedFilters["institutes_ids"][0].id;
                        }
                        if (sanitizedFilters["faculty_tags"] &&
                            sanitizedFilters["faculty_tags"][0]) {
                            sanitizedFilters["faculty_tags"][0] =
                                sanitizedFilters["faculty_tags"][0].id;
                        }
                        if (sanitizedFilters["tags_ids"] && sanitizedFilters["tags_ids"][0]) {
                            // sanitizedFilters["tags_ids"][0] = sanitizedFilters["tags_ids"][0].id;
                            sanitizedFilters["tags"] = [sanitizedFilters["tags_ids"][0].name];
                            delete sanitizedFilters["tags_ids"];
                        }
                        else {
                            delete sanitizedFilters["tags_ids"];
                        }
                        if (sanitizedFilters["skills_ids"] && sanitizedFilters["skills_ids"][0]) {
                            sanitizedFilters["skills_ids"][0] = sanitizedFilters["skills_ids"][0].id;
                        }
                        if (sanitizedFilters["study_tags_ids"] && sanitizedFilters["study_tags_ids"][0]) {
                            sanitizedFilters["study_tags_ids"][0] = sanitizedFilters["study_tags_ids"][0].id;
                        }
                        if (sanitizedFilters["geolocations_ids"] && sanitizedFilters["geolocations_ids"][0]) {
                            sanitizedFilters["geolocations_ids"][0] = String(sanitizedFilters["geolocations_ids"][0].id);
                        }
                        if (sanitizedFilters['user_status'] && sanitizedFilters['user_status'] !== 'all') {
                            sanitizedFilters['user_status'] = [sanitizedFilters['user_status']];
                        }
                        else {
                            delete sanitizedFilters['user_status'];
                        }
                        delete sanitizedFilters['status'];
                        return [4 /*yield*/, this.candidatesService.exportTool(sanitizedFilters)];
                    case 1:
                        blob = _a.sent();
                        a = document.createElement('a');
                        objectUrl = URL.createObjectURL(blob);
                        a.href = objectUrl;
                        a.download = 'data.csv';
                        a.click();
                        URL.revokeObjectURL(objectUrl);
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                _this.exporting = false;
                                _this.disabled = false;
                                // this.modalRef.hide();
                                resolve(output);
                            })];
                }
            });
        });
    };
    TalentPoolExportBtnComponent.prototype.finalizeCSV = function (csv) {
        var link;
        link = document.createElement("a");
        var formBlob = new Blob([csv], { type: "text/csv" });
        link.href = window.URL.createObjectURL(formBlob);
        link.setAttribute("download", moment().format("DD-MM-YYYY") + "_" + "candidates.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.exporting = false;
        this.modalRef.hide();
    };
    TalentPoolExportBtnComponent.prototype.openModal = function (template) {
        this.template = template;
        this.modalRef = this.modalService.show(template);
    };
    TalentPoolExportBtnComponent.prototype.changeSeparator = function (event) {
        this.separator = event.target.value;
    };
    return TalentPoolExportBtnComponent;
}());
export { TalentPoolExportBtnComponent };
